import { IconButton, Tooltip } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { convertToCurrency } from '../../../functions/convertCurrency';
import SystemTextField from './SystemTextField';
import Grid from '@mui/material/Grid';
import styles from '../styles/roi.module.scss'
import { useROIContext } from '../../../context/roiContext';
import * as MODES from '../../../constants/modes'
import { useSystemContext } from '../../../context/systemContext';

const SystemBlock = ({system}) => {
 
    const {addSystem, roi, changeSystemPrice, roiMode} = useROIContext()
    const {addUpgradedSystem} = useSystemContext()

    return (
      <Grid item xs={12} container key={system.id} className={styles.systemBlock} alignItems='center'>
      <Grid item xs={3}>
        {system.logo ? <img src={system.logoURL} alt={system.name} id={system.id} className={styles.brandLogo} /> : ''}
      </Grid>
      <Grid item xs={9} className={styles.textFieldBlock}>
        {roi.systems ? (
          roi.systems[system.id] ? (
            <>
              {roiMode === MODES.capital ? (
                <SystemTextField
                  InputProps={{
                    startAdornment: '$',
                  }}
                  id={`system${system.id}`}
                  variant='standard'
                  value={convertToCurrency(roi.systems[system.id].price ?? 0)}
                  onChange={(event) => changeSystemPrice(system.id, event.target.value)}
                />
              ) : (
                ''
              )}
            </>
          ) : (
            <Tooltip title={`Add ${system.name}`}>
              <IconButton aria-label={`Add ${system.name}`} onClick={() =>  addSystem(system.id) }>
                <AddCircleIcon className={styles.buttons} />
              </IconButton>
            </Tooltip>
          )
        ) : (
          <Tooltip title={`Add ${system.name}`}>
            <IconButton aria-label={`Add ${system.name}`} onClick={() => addSystem(system.id)}>
              <AddCircleIcon className={styles.buttons} />
            </IconButton>
          </Tooltip>
        )}
      </Grid>
    </Grid>
    )

  }

  export default SystemBlock